/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Broker_Col_MatchInputs */

const cs_import_broker_col_match = /** @type {(inputs: Import_Broker_Col_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoda`)
};

const en_import_broker_col_match = /** @type {(inputs: Import_Broker_Col_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match`)
};

/**
* | output |
* | --- |
* | "Match" |
*
* @param {Import_Broker_Col_MatchInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_broker_col_match = /** @type {((inputs?: Import_Broker_Col_MatchInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Broker_Col_MatchInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_broker_col_match(inputs)
	return cs_import_broker_col_match(inputs)
});